import { render } from "./Footer.vue?vue&type=template&id=54cbdcb1&scoped=true"
import script from "../js/footer.js?vue&type=script&lang=js&external"
export * from "../js/footer.js?vue&type=script&lang=js&external"

import "./Footer.vue?vue&type=style&index=0&id=54cbdcb1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cbdcb1"]])

export default __exports__